import useAddCoupon from "../../../hooks/useAddCoupon";
import useReduxSwr from "../../global/hooks/useReduxSwr";
import { retrieve_cart_action } from "../cart-actions";
import { retrieve_cart_fetcher } from "../cart-fetchers";
import { cartSelector } from "../cart-selectors";
import { Cart, CartRetrieveOptions, UseCartApi } from "../cart-types";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import userSelectors from "../../../ducks/user/selectors";

function useCart(): UseCartApi {
  let dispatch = useDispatch();
  let authenticated: boolean = useSelector(userSelectors.getToken);

  let {
    data: cartData,
    isValidating: isCartValidating,
    revalidate: revalidateCart,
    error: cartError,
  } = useReduxSwr<Cart | null>({
    fetcher: retrieve_cart_fetcher,
    selector: cartSelector,
    onFinished: (data) => {
      dispatch(retrieve_cart_action(data));
    },
    enabled: false,
  });
  let [retrieveForced, setForceForRetrieve] = useState(false);
  let {
    addCoupon,
    loading: loadingCoupon,
    removeCoupon,
  } = useAddCoupon(cartData?.id);

  function retrieve(options: CartRetrieveOptions = {}) {
    let { force = false } = options;

    if (!isCartValidating && force && !retrieveForced) {
      revalidateCart();
      // We only run revalidating for 1 time.
      setForceForRetrieve(true);
    } else if (!isCartValidating && !cartData && !!authenticated) {
      revalidateCart();
    }

    return {
      loading: isCartValidating,
      data: cartData,
      error: cartError,
    };
  }

  return {
    retrieve,
    revalidateCart,
    addItem: null,
    removeItem: null,
    updateCoefficient: null,
    coupon: {
      add: addCoupon,
      remove: removeCoupon,
      loading: loadingCoupon,
      code: cartData?.legacyPromotion?.code,
    },
  };
}

export default useCart;
